import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Marketing from './pages/Marketing';
import BackToTop from './components/BackToTop';
import Home from './pages/Home';
import './styles/index.css';

const Work = React.lazy(() => import('./pages/Work'));
const Team = React.lazy(() => import('./pages/Team'));
const About = React.lazy(() => import('./pages/About'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const Terms = React.lazy(() => import('./pages/Terms'));
const DataDeletion = React.lazy(() => import('./pages/DataDeletion'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const Keanu = React.lazy(() => import('./pages/team/Keanu'));
const Justin = React.lazy(() => import('./pages/team/Justin'));

/**
 * Pages that were folded into the single home page. Vercel redirects these
 * with a 308 before the app ever loads; these routes are the client-side
 * safety net for anyone already inside the SPA.
 */
const RETIRED_PATHS = [
  '/ai-solutions',
  '/departments',
  '/audit',
  '/integrations',
  '/templates',
  '/local-setups',
  '/security',
  '/services',
  '/pricing',
] as const;

const PageLoadingFallback: React.FC = () => <div className="page-loading-fallback" />;

const App: React.FC = () => (
  <Router>
    <ScrollToTop />
    <Header />
    <main className="main-content" id="main">
      <Suspense fallback={<PageLoadingFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/team" element={<Team />} />
          <Route path="/work" element={<Work />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/team/keanu" element={<Keanu />} />
          <Route path="/team/justin" element={<Justin />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          {RETIRED_PATHS.map((path) => (
            <Route key={path} path={path} element={<Navigate to="/" replace />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </main>
    <Footer />
    <BackToTop />
    <Analytics />
  </Router>
);

export default App;
